<div class="server-timing">
  <div class="controls">
    <form [formGroup]="form">
      <app-input-field
        [control]="form.controls.search"
        [noLabel]="true"
        [smallNoLabel]="true"
        [verySmallNoLabel]="true"
        class="headless"
      >
        <input type="search" formControlName="search" placeholder="Search" />
      </app-input-field>
    </form>
    <div class="spacer"></div>
    <button
      appButton
      name="DONTREPORT"
      [iconButton]="true"
      (click)="addMark()"
      height="1"
      color="simple"
      appTooltip="Mark"
    >
      <app-svg src="/assets/icons/tag-filled.svg"></app-svg>
    </button>
    <button
      appButton
      name="DONTREPORT"
      [iconButton]="true"
      (click)="serverTimingData = []"
      height="1"
      color="simple-warn"
      appTooltip="Clear"
    >
      <app-svg src="/assets/icons/trash.svg"></app-svg>
    </button>
  </div>
  @if (filterBySearch(serverTimingData) | sortBy: '-responseTime'; as entries) {
    <div class="entries">
      @if (!entries.length) {
        <div class="no-entries">No results found</div>
      }
      @for (entry of entries; track entry) {
        <div class="entry">
          @if (entry.url === 'mark') {
            <div class="mark"></div>
          }
          @if (entry.url !== 'mark') {
            <app-toggler [open]="openStates[entry.url]" [color]="'grey-80'">
              <span togglerHeader class="toggler-header">
                <div class="method {{ entry.method }}">{{ entry.method }}</div>
                <div class="url" [appTooltip]="entry.url" toolTipOrigin="top-left">{{ cleanUrl(entry.url) }}</div>
                <div
                  class="time"
                  [appTooltip]="entry.responseTime | date: 'HH:mm:ss'"
                  [class.grey]="entry.totalTimeTaken > 15"
                  [class.orange]="entry.totalTimeTaken > 30"
                  [class.red]="entry.totalTimeTaken > 50"
                >
                  {{ entry.totalTimeTaken | number: '1.0' }}ms
                </div>
              </span>
              <div togglerBody class="toggler-body">
                @if (entry.requestBody) {
                  <div class="request-body">{{ entry.requestBody }}</div>
                }
                @for (row of entry.rows; track row) {
                  <div class="row">
                    <div class="top">
                      @if (row.type === 'db') {
                        <app-svg
                          src="/assets/icons/database.svg"
                          appTooltip="Database Query"
                          toolTipOrigin="top-left"
                          size="0"
                        ></app-svg>
                      }
                      @if (row.type === 'stripe') {
                        <app-svg
                          src="/assets/icons/special/stripe.svg"
                          appTooltip="Stripe API call"
                          toolTipOrigin="top-left"
                          size="0"
                        ></app-svg>
                      }
                      @if (row.type !== 'db' && row.type !== 'stripe') {
                        Unknown type: {{ row.type }}
                      }
                      <div class="id">{{ row.id }}</div>
                      <div
                        class="time-taken"
                        [class.grey]="row.timeTaken > 2"
                        [class.orange]="row.timeTaken > 5"
                        [class.red]="row.timeTaken > 10"
                      >
                        {{ row.timeTaken }}ms
                      </div>
                    </div>
                    <div class="description">{{ row.description }}</div>
                  </div>
                }
              </div>
            </app-toggler>
          }
        </div>
      }
    </div>
  }
</div>
